import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from '@/shared/components/Button/Button';

export const RefreshButton = ({ onClick }: { onClick: () => void }) => (
    <Button variant="accent" onClick={onClick} size={44}>
        <FormattedMessage
            id="components.RefreshButton.63a6a88c066880c5ac42394a22803ca6"
            defaultMessage="Refresh"
            description="Текст кнопки обновить в компонентах"
        />
    </Button>
);
